import React, { useState, useEffect } from 'react';
import axios from 'axios';

const EditorInChief = () => {
  const [editorData, setEditorData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchEditorData();
  }, []);

  const fetchEditorData = async () => {
    try {
      // Simulated API call - replace with actual endpoint
      const response = await axios.get('/api/editor-in-chief');
      setEditorData(response.data);
    } catch (err) {
      // Use placeholder data if API fails
      setEditorData({
        name: "Prof. Abdullahi Bala Usman",
        title: "Editor-in-Chief",
        position: "Professor of Agricultural Economics",
        department: "Department of Agricultural Economics and Extension",
        institution: "Federal University Wukari",
        email: "editor@fuwukari.edu.ng",
        phone: "+234 XXX XXX XXXX",
        biography: "Prof. Abdullahi Bala Usman is a distinguished Professor of Agricultural Economics with over 20 years of experience in research and academia. He holds a Ph.D. in Agricultural Economics from Ahmadu Bello University, Zaria, and has published extensively in peer-reviewed journals.",
        qualifications: [
          "Ph.D. Agricultural Economics, Ahmadu Bello University, Zaria (2005)",
          "M.Sc. Agricultural Economics, University of Nigeria, Nsukka (1998)",
          "B.Sc. Agriculture, Bayero University, Kano (1995)"
        ],
        researchInterests: [
          "Agricultural Policy Analysis",
          "Rural Development",
          "Farm Management",
          "Agricultural Marketing",
          "Food Security"
        ],
        achievements: [
          "Fellow, Nigerian Institute of Management (2018)",
          "Best Researcher Award, Federal University Wukari (2020)",
          "Outstanding Publication Award, Nigerian Agricultural Economics Association (2019)"
        ]
      });
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="container py-4">
        <div className="text-center">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container py-4">
      <div className="row mb-5">
        <div className="col-lg-8 mx-auto">
          <h1 className="mb-4 text-center">Editor-in-Chief</h1>
          
          <div className="card mb-5">
            <div className="card-body">
              <div className="row">
                <div className="col-md-4 text-center mb-4">
                  <div className="bg-light rounded-circle mx-auto mb-3" style={{width: '150px', height: '150px', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                    <i className="fas fa-user fa-4x text-muted"></i>
                  </div>
                  <h3>{editorData?.name}</h3>
                  <p className="text-muted">{editorData?.title}</p>
                </div>
                <div className="col-md-8">
                  <h4>Contact Information</h4>
                  <p><strong>Position:</strong> {editorData?.position}</p>
                  <p><strong>Department:</strong> {editorData?.department}</p>
                  <p><strong>Institution:</strong> {editorData?.institution}</p>
                  <p><strong>Email:</strong> <a href={`mailto:${editorData?.email}`}>{editorData?.email}</a></p>
                  <p><strong>Phone:</strong> {editorData?.phone}</p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="card mb-5">
            <div className="card-body">
              <h3 className="card-title">Biography</h3>
              <p className="card-text">{editorData?.biography}</p>
            </div>
          </div>
          
          <div className="card mb-5">
            <div className="card-body">
              <h3 className="card-title">Educational Qualifications</h3>
              <ul className="list-unstyled">
                {editorData?.qualifications?.map((qualification, index) => (
                  <li key={index} className="mb-2">
                    <i className="fas fa-graduation-cap text-primary me-2"></i>
                    {qualification}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          
          <div className="card mb-5">
            <div className="card-body">
              <h3 className="card-title">Research Interests</h3>
              <div className="row">
                <div className="col-12">
                  <ul className="list-unstyled">
                    {editorData?.researchInterests?.map((interest, index) => (
                      <li key={index} className="mb-2">
                        <i className="fas fa-check-circle text-success me-2"></i>
                        {interest}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
          
          <div className="card mb-5">
            <div className="card-body">
              <h3 className="card-title">Awards and Achievements</h3>
              <ul className="list-unstyled">
                {editorData?.achievements?.map((achievement, index) => (
                  <li key={index} className="mb-2">
                    <i className="fas fa-award text-warning me-2"></i>
                    {achievement}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          
          <div className="card mb-5">
            <div className="card-body">
              <h3 className="card-title">Editorial Message</h3>
              <p className="card-text">
                "Welcome to the Federal University Wukari Journal of Agriculture and Life Sciences. 
                As Editor-in-Chief, I am committed to maintaining the highest standards of scholarly 
                publishing and promoting research excellence in agriculture and life sciences.
              </p>
              <p className="card-text">
                Our journal serves as a platform for researchers, academics, and practitioners to 
                share innovative research findings that address the challenges facing agriculture 
                in developing countries. We particularly encourage submissions that contribute to 
                sustainable development and food security.
              </p>
              <p className="card-text">
                I invite you to explore our publications, consider submitting your research, 
                and join our community of scholars dedicated to advancing knowledge in agriculture 
                and life sciences."
              </p>
              <p className="text-end">
                <strong>Prof. Abdullahi Bala Usman</strong><br />
                <em>Editor-in-Chief, FUWJALS</em>
              </p>
            </div>
          </div>
          
          <div className="text-center">
            <a href={`mailto:${editorData?.email}`} className="btn btn-primary me-3">
              Contact Editor-in-Chief
            </a>
            <a href="/editorial-board" className="btn btn-outline-secondary">
              View Editorial Board
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditorInChief;